import { apiBackOffice, apiRoteirizacao } from "./utils/api";

export const getClientSearch = async (idPesquisa) => {
  if (!navigator.onLine) {
    return null;
  }
  const response = await apiRoteirizacao.get(`/api/PesquisaCampoCliente/${idPesquisa}`);
  return response.data;
};

export const getSearchs = async () => {
  if (!navigator.onLine) {
    return null;
  }

  const response = await apiRoteirizacao.get(`/api/PesquisaCampoCliente`);
  return response.data;
};


export const getReflex = async () => {
  if (!navigator.onLine) {
    return null;
  }

  const response = await apiRoteirizacao.get(`/api/Reflex`);
  return response.data;
};


export const saveSearchs = async (formData) => {
  if (!navigator.onLine) {
    return null;
  }

  const response = await apiRoteirizacao.post(`/api/PesquisaCampoCliente`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response;
};

export const getClientSearchFile = async (idPesquisa, fileNome) => {
  if (!navigator.onLine) {
    return null;
  }

  const response = await apiBackOffice.get(`/api/PesquisaCampoCliente/Documento/${idPesquisa}/${fileNome}`);
  return response;
};

